import { useAuthStore } from '../store/authStore'

export function authRouteGuard(to, from, next) {
  const authStore = useAuthStore()
  if (to.name !== 'Login' && !authStore.isAuthenticated) next({ name: 'Login' })
  if (to.name === 'Login' && authStore.isAuthenticated) next({ name: 'Home' })
  else next()
  // next()
}

export function disabledRouteGuard(to, from, next) {
  const authStore = useAuthStore()
  console.log(
    'disabledRouteGuard',
    authStore.user?.attributes.activated,
    authStore.can('list', 'UserLicenseToken'),
  )
  if (authStore.user?.attributes.activated === false && to.name !== 'UserLicenses') {
    if (authStore.can('list', 'UserLicenseToken')) {
      console.log('redirecting to UserLicenses')
      next({ name: 'UserLicenses' })
    } else {
      console.log('redirecting to login')
      authStore.logout()
      next({ name: 'Login' })
    }
  } else next()
  // next()
}
